module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Smart & Safe Driving School","short_name":"Smart & Safe","start_url":"/","background_color":"#09548e","theme_color":"#09548e","display":"standalone","icon":"src/images/logo3.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fa0aa7d7ea7f0f33336c10e064aac637"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
